import SweetAlert from 'sweetalert2';

// FM-themed mixin — keeps all call sites unchanged while applying
// the Flash Money design tokens (amber confirm, warm-grey cancel, etc.)
export const FmSwal = SweetAlert.mixin({
    customClass: {
        popup:         'fm-swal-popup',
        title:         'fm-swal-title',
        confirmButton: 'fm-swal-btn fm-swal-btn--confirm',
        cancelButton:  'fm-swal-btn fm-swal-btn--cancel',
        denyButton:    'fm-swal-btn fm-swal-btn--deny',
        closeButton:   'fm-swal-close',
    },
    buttonsStyling: false,
    showCloseButton: true,
    // Ensure SweetAlert sits above FmSelect's fixed dropdown (z-index: 1060)
    // which is bundled into the shared dist/css/app.css loaded on admin pages.
    zIndex: 9999,
});

export const confirm = ({question, confirmButtonText}) => {
    return FmSwal.fire({
        titleText: 'Please Confirm',
        text: question,
        type: 'question',
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: confirmButtonText ? confirmButtonText : 'Ok',
        cancelButtonText: 'Cancel',
    });
};

export const confirmProcess = (title, text, confirm, cancel = 'No', showCancelButton = true) => {
    return FmSwal.fire({
        titleText: title,
        text: text,
        type: 'info',
        showConfirmButton: true,
        showCancelButton: showCancelButton ?? false,
        confirmButtonText: confirm,
        cancelButtonText: cancel,
    });
};

export const success = ({message}) => {
    return FmSwal.fire({
        titleText: 'success',
        text: message,
        type: 'success',
    });
};

export const html = ({html, target, type, titleText = null, icon = null, ...rest}) => {
    const customClass = {};

    if (!titleText) {
        customClass.title = 'hide';
    }

    if (!icon) {
        customClass.icon = 'hide';
        customClass.actions = 'hide';
    }

    if (target) {
        target = document.querySelector(target);
    }

    return FmSwal.fire({
        ...rest,
        html,
        icon,
        type,
        titleText,
        target: target ?? 'body',
        showConfirmButton: false,
        customClass,
    });
};

export const error = ({message}) => {
    return FmSwal.fire({
        titleText: 'Error',
        text: message,
        type: 'error',
    });
};

export const errorP2 = (title, text, confirm, cancel = 'No', showCancelButton = true) => {
    return FmSwal.fire({
        titleText: title,
        text: text,
        type: 'error',
        showConfirmButton: true,
        showCancelButton: showCancelButton ?? false,
        confirmButtonText: confirm,
        cancelButtonText: cancel,
    });
};

export const image = imageUrl => FmSwal.fire({
    imageUrl,
    width: '50rem',
    padding: 0,
    customClass: {
        actions: 'hide',
        image: 'p-0 m-0',
    },
});

export const fire = (...args) => FmSwal.fire(...args);

export default {
    confirm,
    confirmProcess,
    error,
    errorP2,
    success,
    image,
    html,
    fire,
};
